// extracted by mini-css-extract-plugin
export var linkArrow = "RelatedContent-module--linkArrow--75026";
export var linkLabel = "RelatedContent-module--linkLabel--1c50f";
export var relatedGrid = "RelatedContent-module--relatedGrid--267ca";
export var relatedImg = "RelatedContent-module--relatedImg--baf26";
export var relatedItem = "RelatedContent-module--relatedItem--c3b7d";
export var relatedLink = "RelatedContent-module--relatedLink--bc986";
export var relatedWrapper = "RelatedContent-module--relatedWrapper--0a473";